import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  error: "",
  loading: false,
  message: "",
};

const commonSlice = createSlice({
  name: "commonData",
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.error = "";
      state.message = "";
      state.loading = true;
    },
    fetchSuccess: (state) => {
      state.error = "";
      state.message = "";
      state.loading = false;
    },
    showMessage: (state, action) => {
      state.error = "";
      state.message = action.payload;
      state.loading = false;
    },
    fetchError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.message = "";
    },
    hideMessage: (state) => {
      state.loading = false;
      state.error = "";
      state.message = "";
    },
  },
});

export const {
  fetchStart,
  fetchSuccess,
  showMessage,
  fetchError,
  hideMessage,
} = commonSlice.actions;

export default commonSlice.reducer;
